import { render } from "./registrados.vue?vue&type=template&id=1dcde9d4&scoped=true"
import script from "./registrados.vue?vue&type=script&lang=js"
export * from "./registrados.vue?vue&type=script&lang=js"

import "./registrados.vue?vue&type=style&index=0&id=1dcde9d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dcde9d4"]])

export default __exports__